import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import EditAlbumModal from "../../Models/EditAlbumModel/editAlbum";
import { deleteUpdate, albumGet } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Lodderr from "../../components/Lodder/Lodder";
import { useLocation } from "react-router-dom";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { motion } from "framer-motion";
import "./AlbumsCards.css";
const AlbumsCard = () => {
  const myCompanyId = Cookies.get("company_id");
  const UserID = Cookies.get("userID");

  const [showModel, setShowModel] = useState(false);
  const [albumData, setalbumData] = useState(null);
  const [albumToDelete, setAlbumToDelete] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const galleryCompanyId =
    location.state?.company_id != null && location.state?.company_id !== ""
      ? String(location.state.company_id)
      : String(myCompanyId || "");

  useEffect(() => {
    if (galleryCompanyId) {
      dispatch(albumGet({ company_id: galleryCompanyId }));
    }
  }, [dispatch, galleryCompanyId]);


  const { album, loading } = useSelector((state) => state.GallerySlice);

  const handleClick = (albumItem) => {
    navigate("/albums-gallery", {
      state: {
        album: albumItem,
        from: location.pathname
      }
    });
  };
  

  const handleEdit = (albumItem) => {
    setalbumData(albumItem);
    setShowModel(true);
  };

  const handleDelete = async () => {
    if (albumToDelete) {
      const response = await dispatch(
        deleteUpdate({ id: albumToDelete.album_id })
      );

      if (response.payload?.status === "success") {
        toast.success("Album deleted successfully!");
        await dispatch(albumGet({ company_id: galleryCompanyId }));
        setAlbumToDelete(null);
      } else {
        toast.error("Error while deleting album");
      }
    }
  };

  if (typeof album?.result === "string") {
    toast.error(album.result);
  }

  return (
    <>
      {loading && <Lodderr />}

      <EditAlbumModal
        showModal={showModel}
        closeModal={() => setShowModel(false)}
        albumData={albumData}
      />

      <motion.div
        className="ac-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="ac-hero">
          <div>
            <h1 className="ac-title">Albums</h1>
            <p className="ac-sub">Browse your album collections with a clean premium view.</p>
          </div>
          <div className="ac-count">
            <i className="bx bx-photo-album"></i>{" "}
            {Array.isArray(album?.result) ? album.result.length : 0} albums
          </div>
        </div>

        <div className="ac-grid">
          {Array.isArray(album?.result) && album.result.length > 0 ? (
            album.result.map((albumItem, idx) => {
              const canEdit =
                UserID == albumItem?.data?.[0]?.member_id &&
                myCompanyId == albumItem?.data?.[0]?.company_id;
              const media = albumItem.data || [];

              return (
                <motion.article
                  key={albumItem.album_id}
                  className="ac-card"
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    delay: idx * 0.03,
                    duration: 0.35,
                    ease: [0.22, 0.68, 0, 1.2],
                  }}
                  whileHover={{ y: -6 }}
                >
                  <div className="ac-card-top">
                    <span className="ac-chip">
                      <i className="bx bx-images"></i> {media.length} items
                    </span>

                    {canEdit && (
                      <div className="ac-actions">
                        <button
                          className="ac-kebab"
                          onClick={() =>
                            setOpenDropdownId(
                              openDropdownId === albumItem.album_id
                                ? null
                                : albumItem.album_id
                            )
                          }
                          aria-label="Album actions"
                        >
                          <i className="bx bx-dots-vertical-rounded"></i>
                        </button>

                        {openDropdownId === albumItem.album_id && (
                          <div className="ac-menu">
                            <button
                              className="ac-menu-item"
                              onClick={() => {
                                setOpenDropdownId(null);
                                handleEdit(albumItem);
                              }}
                            >
                              <i className="bx bx-edit-alt"></i> Edit
                            </button>
                            <button
                              className="ac-menu-item danger"
                              onClick={() => {
                                setAlbumToDelete(albumItem);
                                setOpenDropdownId(null);
                              }}
                            >
                              <i className="bx bx-trash"></i> Delete
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <button className="ac-main" onClick={() => handleClick(albumItem)} type="button">
                    <h3 className="ac-name">{albumItem.title}</h3>

                    <div className="ac-mosaic">
                      {media.slice(0, 4).map((item, i) => (
                        <div key={`${albumItem.album_id}-${i}`} className="ac-mosaic-item">
                          {item.extension_type === "image" && (
                            <img src={item.file_url} alt="" loading="lazy" />
                          )}
                          {item.extension_type === "video" && (
                            <div className="ac-video">
                              <video src={item.file_url} muted />
                              <span className="ac-play">
                                <i className="bx bx-play"></i>
                              </span>
                            </div>
                          )}
                          {item.extension_type === "audio" && (
                            <div className="ac-audio">
                              <i className="bx bx-music"></i>
                            </div>
                          )}
                        </div>
                      ))}

                      {media.length === 0 && (
                        <div className="ac-empty-thumb">
                          <i className="bx bx-photo-album"></i>
                          <span>No media yet</span>
                        </div>
                      )}
                    </div>
                  </button>
                </motion.article>
              );
            })
          ) : (
            <div className="ac-empty">
              <i className="bx bx-photo-album"></i>
              <p>No albums found.</p>
            </div>
          )}
        </div>
      </motion.div>

      <ConfirmModal
        isOpen={!!albumToDelete}
        message="Are you sure you want to delete this album?"
        onCancel={() => setAlbumToDelete(null)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default AlbumsCard;
